import React, { useContext, useMemo, useEffect } from "react";
import $ from "jquery";
import { useDetectClickOutside } from "react-detect-click-outside";
import {
    IBulkActionDropDown,
    IMainContext,
    SubModule,
    ParentModule,
    Features,
} from "@ts/common-types";
import { FaAngleDown } from "react-icons/fa";
import { CERBOS_PERMISSIONS_COMP_TYPES, mainContext } from "@/ts/constants";
import { getActiveModule } from "@/ts/utils";
import { usePermissionCheck } from "@/hooks/AllCustomHooks";
import { Button } from "antd";

interface IBulkActionDropDownData {
    data: IBulkActionDropDown[];
}

const BulkActionsMenu: React.FC<IBulkActionDropDownData> = ({ data }) => {
    const menuRef = React.useRef<HTMLDivElement>(null);

    const ref = useDetectClickOutside({
        onTriggered: () => {
            if (menuRef.current) {
                $(menuRef.current).find("#pa-bulk-action-drop-down").hide();
            }
        },
    });

    useEffect(() => {
        const dropDown = $("#pa-bulk-action-drop-down");
        if (dropDown.length && !menuRef.current?.contains(dropDown[0])) {
            dropDown.remove();
        }
    }, []);

    const { cerbosPermissions } = useContext<IMainContext>(mainContext);
    const activeModule = getActiveModule();

    const {
        canCreateCampaign,
        canUpdateCampaign,
        canManageDayParting,
        canCreateKeyword,
        canUpdateKeyword,
        canCreateNegativeKeyword,
        canDeleteNegativeKeyword,
        canRevertActionInHistory,
        canUpdateInProductAnalytics,
        canCreateBuyBox,
        canDeleteBuyBox,
        canPerformBulkActions,
    } = usePermissionCheck();

    const { isModuleEditDisabled } = usePermissionCheck({
        type: CERBOS_PERMISSIONS_COMP_TYPES.CELL_RENDERER,
    });

    const disabledBulkActions = useMemo(() => {
        const disableBulkActions = [];

        if (
            (!canUpdateCampaign &&
                activeModule.activeModule === SubModule.CAMPAIGN) ||
            (!canUpdateKeyword &&
                activeModule.activeModule === SubModule.KEYWORD)
        ) {
            disableBulkActions.push(Features.PAUSE);
            disableBulkActions.push(Features.ENABLE);
            disableBulkActions.push(Features.TAGS_ADDITION);
        }

        if (
            (!canUpdateCampaign &&
                activeModule.activeModule === SubModule.CAMPAIGN) ||
            !canPerformBulkActions
        ) {
            disableBulkActions.push(Features.BULK_ACTION);
            // !disableBulkActions.includes("enable") && disableBulkActions.push("enable")
        }

        if (
            !canCreateCampaign &&
            activeModule.activeModule === ParentModule.PRODUCT_ANALYTICS
        ) {
            disableBulkActions.push(Features.CREATE_CAMPAIGN);
            data = data.filter(
                (options) => options.operation !== Features.CREATE_CAMPAIGN
            );
        }

        if (!canManageDayParting) {
            disableBulkActions.push(Features.DAY_PARTING);
        }

        if (
            !canCreateKeyword &&
            activeModule.activeModule === ParentModule.KEYWORD_ANALYTICS
        ) {
            // disableBulkActions.push("bulk-target-actions")
            disableBulkActions.push(Features.ADD_AS_EXACT);
        }
        if (
            !canUpdateKeyword &&
            activeModule.activeModule === SubModule.KEYWORD
        ) {
            disableBulkActions.push(Features.BID);
            disableBulkActions.push(Features.MARK_NEGATIVE);
        }

        if (!canCreateNegativeKeyword) {
            disableBulkActions.push(Features.ADD_NEGATIVE);
        }

        if (!canDeleteNegativeKeyword) {
            disableBulkActions.push(Features.REMOVE_NEGATIVE);
        }

        if (!canRevertActionInHistory) {
            disableBulkActions.push(Features.REVERT_ACTION);
        }
        if (
            !canUpdateInProductAnalytics &&
            activeModule.activeModule === ParentModule.PRODUCT_ANALYTICS
        ) {
            disableBulkActions.push(Features.ENABLE_ALL);
            disableBulkActions.push(Features.PAUSE_ALL);
        }
        if (
            isModuleEditDisabled &&
            activeModule.activeModule === SubModule.PRODUCT
        ) {
            disableBulkActions.push(Features.ENABLE_ALL);
            disableBulkActions.push(Features.PAUSE_ALL);
        }
        if (!canCreateBuyBox) {
            disableBulkActions.push(Features.ADD_TO_BUYBOX);
        }
        if (!canDeleteBuyBox) {
            disableBulkActions.push(Features.REMOVE_BUYBOX as string);
        }

        return disableBulkActions;
    }, [cerbosPermissions]);

    return (
        <div ref={ref}>
            <div ref={menuRef}>
                <Button
                    id="pa-bulk-action-select"
                    style={{
                        fontWeight: 400,
                        fontSize: 14
                    }}
                    onClick={(e) => {
                        e.stopPropagation();
                        if (menuRef.current) {
                            const dropDown = $(menuRef.current).find(
                                "#pa-bulk-action-drop-down"
                            );
                            dropDown.toggle();
                        }
                    }}
                >
                    Bulk Actions{" "}
                    <FaAngleDown
                        className="text-dark"
                        style={{ fontWeight: "900" }}
                    />
                </Button>
                <div className="card shadow" id="pa-bulk-action-drop-down">
                    {data &&
                        data.map((cardData, index) => {
                            return !disabledBulkActions.includes(
                                cardData.type
                            ) ? (
                                <div key={index}>
                                    {cardData.element ? (
                                        cardData.element
                                    ) : (
                                        <div
                                            className="pa-bulk-action-drop-down-option"
                                            onClick={() => cardData.fn()}
                                            key={cardData.text}
                                        >
                                            {cardData.icon} &nbsp;
                                            {cardData.text}
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <div key={index}>
                                    <div
                                        className="pa-bulk-action-drop-down-option-disable"
                                        key={cardData.text}
                                    >
                                        {cardData.icon} &nbsp;{cardData.text}
                                    </div>
                                </div>
                            );
                        })}
                </div>
            </div>
        </div>
    );
};

export default BulkActionsMenu;
